import type { ReactNode } from 'react';

interface BsTooltipProps {
  title: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
  children: ReactNode;
}

// Small tooltip wrapper. The app does not wire Bootstrap's JS tooltip plugin in
// React (the rest of the port uses the native `title` attribute — see the
// ProviderFunds "Excess" widget), so this renders a span carrying `title` +
// the Bootstrap data attributes, which gives a hover tooltip without jQuery.
export function BsTooltip({ title, placement = 'top', className, children }: BsTooltipProps) {
  return (
    <span className={className} title={title} data-bs-toggle="tooltip" data-bs-placement={placement}>
      {children}
    </span>
  );
}
